// Module
var code = "<span class=\"tags__item-title\" title=\"<@- name @>\"><@- name @></span>\n";
// Exports
export default code;